function isNumeric(smth) {
  return typeof smth === "number" && !isNaN(smth);
}

function degreesToRadians(angleDegrees) {
  return (angleDegrees * Math.PI) / 180;
}

function radiansToDegrees(angleRadians) {
  return (angleRadians * 180) / Math.PI;
}

function findSignedAngle(p0, p1, p2) {
  // Calculate vectors from the vertex (p1) to the other two points
  const v1x = p0.x - p1.x;
  const v1y = p0.y - p1.y;

  const v2x = p2.x - p1.x;
  const v2y = p2.y - p1.y;

  // Use Math.atan2 to get the angle of each vector relative to the positive x-axis
  const angle1 = Math.atan2(v1y, v1x);
  const angle2 = Math.atan2(v2y, v2x);

  // Calculate the difference between the angles
  let signedAngle = angle2 - angle1;

  // Normalize the angle to be within -PI and PI
  if (signedAngle > Math.PI) {
    signedAngle -= 2 * Math.PI;
  } else if (signedAngle < -Math.PI) {
    signedAngle += 2 * Math.PI;
  }
  // Convert radians to degrees if desired
  const angleDeg = signedAngle * (180 / Math.PI);

  return angleDeg; // Angle in radians
}

function findAngle(A, B, C) {
  var AB = Math.sqrt(Math.pow(B.x - A.x, 2) + Math.pow(B.y - A.y, 2));
  var BC = Math.sqrt(Math.pow(B.x - C.x, 2) + Math.pow(B.y - C.y, 2));
  var AC = Math.sqrt(Math.pow(C.x - A.x, 2) + Math.pow(C.y - A.y, 2));
  const angleRad = Math.acos((BC * BC + AB * AB - AC * AC) / (2 * BC * AB));
  // Convert radians to degrees if desired
  const angleDeg = angleRad * (180 / Math.PI);

  // find_angle
  return angleDeg; // Or return angleRad for radians
}

export {
  isNumeric,
  findSignedAngle,
  findAngle,
  degreesToRadians,
  radiansToDegrees,
};
